import React from 'react'
import TopBar from '../Components/TopBar/TopBar'
import VerificationCode from '../Components/VerificationCode/VerificationCode'

const VerificationCodePage = () => {
  return (
    <div>
        <TopBar/>
        <VerificationCode/>
    </div>
  )
}

export default VerificationCodePage